var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27276"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8938",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Trash-alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0A.75.75 0 0 0 5 .75v.75H.75a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H10.5V.75A.75.75 0 0 0 9.75 0z",
    transform: "translate(4 2)",
    style: {
      fill: "#8c8d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M3.811 2.75 5.28 4.22a.75.75 0 0 1-1.06 1.06L2.75 3.811 1.28 5.28A.75.75 0 0 1 .22 4.22l1.47-1.47L.22 1.28A.75.75 0 1 1 1.28.22l1.47 1.47L4.22.22a.75.75 0 0 1 1.06 1.06z",
    transform: "translate(9 12)",
    style: {
      fill: "#f44336"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.481 15.244a27.133 27.133 0 0 1-3.749-.261 2.851 2.851 0 0 1-2.44-2.51l-.02-.177a44.574 44.574 0 0 1 0-9.826l.2-1.8A.749.749 0 0 1 1.218 0h10.526a.749.749 0 0 1 .745.667l.2 1.8a44.464 44.464 0 0 1 0 9.826l-.019.177a2.852 2.852 0 0 1-2.441 2.51 27.118 27.118 0 0 1-3.748.264zM1.889 1.5l-.126 1.134a43.011 43.011 0 0 0 0 9.5l.02.177A1.354 1.354 0 0 0 2.94 13.5a25.652 25.652 0 0 0 3.541.246 25.652 25.652 0 0 0 3.541-.246 1.354 1.354 0 0 0 1.157-1.191l.02-.177a43.011 43.011 0 0 0 0-9.5L11.073 1.5H1.889z",
    transform: "translate(5.269 7)",
    style: {
      fill: "#8c8d99"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashColored);
export default __webpack_public_path__ + "static/media/trash-colored.acfeb81ad779123cc611fa25c2f82e8f.svg";
export { ForwardRef as ReactComponent };